//
//
//
//
//
//
//
//
//


export default {
  props: {
    value: String,
    subtext: {
      type: String,
      default: '(preset)'
    }
  }
}
